var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.access.Act_List)?_c('div',{staticClass:"kstmod-rec-relatedlist"},[_c('Rows',{attrs:{"access":_vm.access,"items":_vm.items,"client":_vm.client}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }